export default __webpack_public_path__ + "static/media/logo.807528d4.png";